import asyncSeries from 'async/series';
import DeviceHashStore from '../stores/device_hash_store';

import { sendFile } from '../tools/s3_helper';

import { AsyncIterator } from '../tools/async_iterator';
import util from '../tools/util';

const MULTI_LIMIT = 10;
const ERROR_LIMIT = 5;
const RETRY_INTERVAL = 10 * 1000;
const PART_CHECK_TIME = 60 * 1000;

const g_lastCheckMap = new Map<string, any>();

const _checkParts = util.herd(
  (params, done) => {
    const { file_hash } = params;
    DeviceHashStore.createMultipart(params, (err, result) => {
      if (err) {
        util.errorLog(
          'MultipartHelper._checkParts: check err:',
          err,
          file_hash
        );
      } else {
        util.log(
          'MultipartHelper._checkParts: need upload count:',
          result.upload_list.length
        );
        g_lastCheckMap.set(file_hash, { last_time: Date.now(), result });
        if (result?.skip_upload) {
          err = 'skip';
        }
      }
      done(err, result);
    });
  },
  (params) => params.file_hash
);
export function sendParts(
  params: any,
  done: (err: any, check_result?: any) => void
) {
  const { org_id, media_grant_id, file, file_hash, file_size, part_list } =
    params;

  let check_result;
  let done_size = 0;
  let list;
  function _progress(delta: number) {
    const list_size = list.reduce((memo, item) => memo + item.loaded, 0);
    const loaded = done_size + list_size;
    const fraction = loaded / file_size;
    params.progress(fraction, delta, loaded);
  }
  asyncSeries(
    [
      (done) => {
        const opts = {
          org_id,
          media_grant_id,
          file_hash,
          file_size,
          part_list,
        };
        _checkParts(opts, (err, result) => {
          if (!err) {
            let list_size = 0;
            const chunk_size = part_list[0].part_size;
            list = result.upload_list.map((upload, i) => {
              const index = part_list.findIndex(
                (part) => part.part_hash === upload.part_hash
              );
              const part = part_list[index];
              const start_pos = index * chunk_size;
              const part_file = file.slice(
                start_pos,
                start_pos + part.part_size
              );
              list_size += part.part_size;
              const item = {
                loaded: 0,
                file_hash,
                part_num: upload.part_num,
                part_size: part.part_size,
                part_hash: part.part_hash,
                check_opts: {
                  ...opts,
                  part_num: upload.part_num,
                },
                progress: (_, delta: number, loaded: number) => {
                  item.loaded = loaded;
                  _progress(delta);
                },
                file: part_file,
              };
              return item;
            });
            done_size = file_size - list_size;
            util.shuffle(list);
            _progress(0);
          }
          check_result = result;
          done(err);
        });
      },
      (done) => {
        const opts = {
          list,
          limit: MULTI_LIMIT,
          times: ERROR_LIMIT,
          interval: RETRY_INTERVAL,
          iterator: _sendPart,
        };
        const iter = new AsyncIterator(opts);
        iter.on('done', (err) => {
          if (err) {
            util.errorLog('MediaIngest.sendParts: done err:', err, file_hash);
          }
          done(err);
        });
        iter.on('item_done', (item) => {
          item.loaded = item.part_size;
          _progress(0);
        });
        iter.start();
      },
    ],
    (err) => done(err, check_result)
  );
}
function _sendPart(item, done) {
  const { file_hash, part_num, check_opts, file, progress } = item;
  let request: any;
  asyncSeries(
    [
      (done) => {
        _checkPart(check_opts, (err, new_request) => {
          request = new_request;
          done(err);
        });
      },
      (done) => {
        const opts = { request, file, progress };
        sendFile(opts, (err, body) => {
          if (err) {
            util.errorLog(
              'MultipartHelper._sendPart: err:',
              err,
              file_hash,
              part_num,
              body
            );
          } else {
            util.log(
              'MultipartHelper._sendPart: finish part:',
              file_hash,
              part_num
            );
          }
          done(err);
        });
      },
    ],
    (err) => {
      if (err === 'skip') {
        util.log('MultipartHelper._sendPart: skip part:', file_hash, part_num);
        err = null;
      }
      done(err);
    }
  );
}
function _checkPart(params, done) {
  const { file_hash, part_num } = params;
  const last_check = g_lastCheckMap.get(file_hash);
  let check_result = last_check?.result;

  asyncSeries(
    [
      (done) => {
        const last_time = last_check?.last_time ?? 0;
        const delta = Date.now() - last_time;
        if (delta > PART_CHECK_TIME) {
          _checkParts(params, (err, result) => {
            if (!err && result) {
              check_result = result;
            }
            done(err);
          });
        } else {
          done();
        }
      },
    ],
    (err) => {
      let request;
      if (!err && check_result?.skip_upload) {
        err = 'skip';
      } else if (!err) {
        const upload = check_result.upload_list.find(
          (u) => u.part_num === part_num
        );
        if (upload) {
          request = upload.signed_opts;
        } else {
          err = 'skip';
        }
      }
      done(err, request);
    }
  );
}
